var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAllCaughtUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-284"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.78,
    y: 398.49,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.53,
    y: 401.21,
    width: 8.69,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.59,
    y: 389.21,
    width: 19.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 390.89,
    width: 43.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.56,
    y: 390.89,
    width: 6.33,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.47,
    y: 395.11,
    width: 93.68,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.91,260.81H164.37a8.83,8.83,0,0,1,8.83,8.83l12,76.47H59.08l-12-76.47A8.84,8.84,0,0,1,55.91,260.81Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.89,290.38l-.14-.39h42v93h-52V301.14A10.62,10.62,0,0,1,184.89,290.38Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.2,290.36h0A10.77,10.77,0,0,1,238,301.14V383H216.42V301.14A10.77,10.77,0,0,1,227.2,290.36Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.89,290.38l-.14-.39h42v93h-52V301.14A10.62,10.62,0,0,1,63.89,290.38Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.97,
    y: 317.49,
    width: 92.41,
    height: 65.5,
    transform: "translate(326.35 700.47) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.77,310.77h104a0,0,0,0,1,0,0v22.71a0,0,0,0,1,0,0h-104a11.36,11.36,0,0,1-11.36-11.36v0A11.36,11.36,0,0,1,110.77,310.77Z",
    transform: "translate(314.13 644.26) rotate(-180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.2,290.36h0A10.77,10.77,0,0,1,117,301.14V383H95.42V301.14A10.77,10.77,0,0,1,106.2,290.36Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.75,347.24H59.08l-12-77.6a8.84,8.84,0,0,1,8.84-8.83h0a8.83,8.83,0,0,1,8.83,8.83Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "391.69 382.99 414.04 234.49 414.04 382.99 420.04 382.99 420.04 233.56 442.41 382.99 448.84 382.99 420.83 195.95 420.04 196.07 420.04 189.99 414.04 189.99 414.04 196.05 413.21 195.95 385.14 382.99 391.69 382.99",
    style: {
      fill: "#e9e9e9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "447.78 216.69 385.97 216.69 390.97 165.04 442.78 165.04 447.78 216.69",
    style: {
      fill: "#f4f4f4"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.28,
    cy: 104.11,
    r: 23.55,
    transform: "translate(-34.02 51.93) rotate(-24.56)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.28,
    cy: 104.11,
    r: 20.03,
    transform: "translate(-30.91 44.43) rotate(-21.37)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "103.22 90.37 103.22 104.37 112.5 99.12",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.22,105.37a1,1,0,0,1-1-1v-14a1,1,0,0,1,2,0v12.28l7.78-4.4a1,1,0,1,1,1,1.74l-9.28,5.25A1,1,0,0,1,103.22,105.37Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-284"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-284",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-284"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.27,384.65c-.16-1-3.66-25.18,3.35-33.51a7.63,7.63,0,0,1,5.83-2.87c14.15-.33,16.08,11,16.1,11.15l-1.67.26c-.06-.41-1.74-10-14.39-9.72a5.87,5.87,0,0,0-4.57,2.26c-6.53,7.76-3,31.93-3,32.18Z",
    style: {
      fill: "#38BDF8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.41,383.54l-1.69-.05c0-.22.56-22.25-10.29-26.8-10.64-4.46-15.42,4.71-15.62,5.1L61.3,361c.05-.11,5.67-11,17.78-5.9C91,360.13,90.44,382.59,90.41,383.54Z",
    style: {
      fill: "#38BDF8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.46,385.27c0-.35-.1-35.19-6.9-45.37-6.52-9.79-17-5.18-17.48-5l-.7-1.54C65.5,333.33,77.64,328,85,339c7.07,10.61,7.18,44.86,7.18,46.31Z",
    style: {
      fill: "#38BDF8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.47,349.11s-6.18,2.27-4.34,7.65S119.51,371,119.51,371s8.18-7.5.66-19.7S102.64,345.26,102.47,349.11Z",
    style: {
      fill: "#38BDF8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.26,338.06s4.39-.47,4-3.14-17.05-9.55-26.91,1.57c0,0,6.31,10.84,15.43,11S83.26,338.06,83.26,338.06Z",
    style: {
      fill: "#38BDF8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.76,355.91s3-2.44-.24-3.64-19.31-.85-19.47,15c0,0,18.67,3.11,21-2.94S78.76,355.91,78.76,355.91Z",
    style: {
      fill: "#38BDF8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.47,349.11s-6.18,2.27-4.34,7.65S119.51,371,119.51,371s8.18-7.5.66-19.7S102.64,345.26,102.47,349.11Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.26,338.06s4.39-.47,4-3.14-17.05-9.55-26.91,1.57c0,0,6.31,10.84,15.43,11S83.26,338.06,83.26,338.06Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.76,355.91s3-2.44-.24-3.64-19.31-.85-19.47,15c0,0,18.67,3.11,21-2.94S78.76,355.91,78.76,355.91Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.79 417 76.81 417 73.69 385.27 108.92 385.27 105.79 417",
    style: {
      fill: "#38BDF8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.79 417 76.81 417 73.69 385.27 108.92 385.27 105.79 417",
    style: {
      fill: "#fff",
      opacity: 0.5,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.14,
    y: 381.77,
    width: 38.32,
    height: 7,
    style: {
      fill: "#38BDF8"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.14,
    y: 381.77,
    width: 38.32,
    height: 7,
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-284"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 212.32,
    y: 77.53,
    width: 188.74,
    height: 339.47,
    rx: 10.4,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.75,88.9V405a4.62,4.62,0,0,1-4.69,4.62H222.94a4.14,4.14,0,0,1-4.19-4.24V88.52a3.73,3.73,0,0,1,3.59-3.88h41.78a2.94,2.94,0,0,1,2.69,1.88l1.73,4.26a2.94,2.94,0,0,0,2.69,1.86h71.13a2.91,2.91,0,0,0,2.69-1.83l1.73-4.28a3,3,0,0,1,2.69-1.89h41.18A4.22,4.22,0,0,1,394.75,88.9Z",
    style: {
      fill: "#38BDF8"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.75,
    y: 104.39,
    width: 176,
    height: 257.25,
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 302.76,
    cy: 85.06,
    r: 2.42,
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.07,85.06a1.55,1.55,0,1,1-1.55-1.55A1.54,1.54,0,0,1,310.07,85.06Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238.6,
    y: 94.48,
    width: 2.17,
    height: 2.9,
    transform: "translate(479.37 191.86) rotate(180)",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.06,
    y: 93.51,
    width: 2.17,
    height: 3.86,
    transform: "translate(472.29 190.89) rotate(180)",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 231.51,
    y: 92.55,
    width: 2.17,
    height: 4.83,
    transform: "translate(465.2 189.93) rotate(180)",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.97,
    y: 91.58,
    width: 2.17,
    height: 5.8,
    transform: "translate(458.12 188.96) rotate(180)",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 374,
    y: 93.42,
    width: 1.29,
    height: 2.9,
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376.17,
    y: 92.37,
    width: 10.27,
    height: 5.01,
    transform: "translate(762.61 189.75) rotate(180)",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.71,158.78a27.37,27.37,0,1,1-27.37-27.37A27.33,27.33,0,0,1,282.71,158.78Z",
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.41,182.25a27.42,27.42,0,0,1-27,.68c.35-.06.69-.1,1-.14h0l-.06,0c2.62-2.87,2.5-8.81,1.68-14.07a9.55,9.55,0,0,1-.52-1,19.43,19.43,0,0,1-2.39-5.55,7.34,7.34,0,0,1-2.41-3.63,3.51,3.51,0,0,1,1.21-3.89c-.07-.81-.11-1.64-.12-2.47h0s-3.3-3-1.24-4.55,2.52-3.86,3.78-6.53,6.87-6.13,12.82-2.08c0,0,3.16-1.08,4.56-.29a8.39,8.39,0,0,1,2.51,2.87,2.11,2.11,0,0,1,3.2-.1c1.62,1.68.34,7.71,1.72,9.19s-1.22,3.07-1.65,3.35a15,15,0,0,1-.71,2.39,27.73,27.73,0,0,1-2.1,10.9,11.2,11.2,0,0,1-.52,1,10.92,10.92,0,0,1-6.25,5.09,10.39,10.39,0,0,1-1.9.41,9.47,9.47,0,0,0,.37,3.44c.69,2.06,2.37,3.67,5.81,4.24a.13.13,0,0,1,0,.05c.72,0,1.44.08,2.15.08,1.86.11,3.63.3,5.16.49A6.18,6.18,0,0,1,269.41,182.25Z",
    style: {
      opacity: 0.30000000000000004,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 271.58,
    y: 173.94,
    width: 11.88,
    height: 11.88,
    rx: 2.37,
    style: {
      fill: "#38BDF8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.46,179.89a2.94,2.94,0,1,1-2.94-2.95A2.94,2.94,0,0,1,280.46,179.89Z",
    style: {
      opacity: 0.30000000000000004,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.75,144H306.61a3.85,3.85,0,0,1-3.85-3.85h0a3.86,3.86,0,0,1,3.85-3.85h38.14a3.86,3.86,0,0,1,3.85,3.85h0A3.85,3.85,0,0,1,344.75,144Z",
    style: {
      fill: "#fff",
      opacity: 0.5,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.66,158.77H305.07a2.31,2.31,0,0,1-2.31-2.3h0a2.31,2.31,0,0,1,2.31-2.31h60.59a2.31,2.31,0,0,1,2.31,2.31h0A2.31,2.31,0,0,1,365.66,158.77Z",
    style: {
      fill: "#fff",
      opacity: 0.5,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.66,168.77H305.07a2.31,2.31,0,0,1-2.31-2.3h0a2.31,2.31,0,0,1,2.31-2.31h40.59a2.31,2.31,0,0,1,2.31,2.31h0A2.31,2.31,0,0,1,345.66,168.77Z",
    style: {
      fill: "#fff",
      opacity: 0.5,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.48,
    y: 391.91,
    width: 28.09,
    height: 10.08,
    rx: 2.36,
    style: {
      opacity: 0.30000000000000004,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253.92,
    y: 370.5,
    width: 105.2,
    height: 4.62,
    rx: 2.31,
    style: {
      fill: "#fff",
      opacity: 0.5,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268.92,
    y: 380.5,
    width: 75.2,
    height: 4.62,
    rx: 2.31,
    style: {
      fill: "#fff",
      opacity: 0.5,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225.88,
    y: 191.23,
    width: 161.29,
    height: 51.5,
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.4,200.78H303.5a2.19,2.19,0,0,1-2.19-2.19h0a2.19,2.19,0,0,1,2.19-2.19h29.9a2.2,2.2,0,0,1,2.2,2.19h0A2.2,2.2,0,0,1,333.4,200.78Z",
    style: {
      fill: "#fff",
      opacity: 0.5,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.4,209.78H303.5a2.19,2.19,0,0,1-2.19-2.19h0a2.19,2.19,0,0,1,2.19-2.19h57.9a2.2,2.2,0,0,1,2.2,2.19h0A2.2,2.2,0,0,1,361.4,209.78Z",
    style: {
      fill: "#fff",
      opacity: 0.5,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 231.84,
    y: 196.4,
    width: 59.51,
    height: 40.73,
    style: {
      opacity: 0.30000000000000004,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "231.84 227.58 245.95 214.24 257.93 225.92 268.34 215.82 291.35 237.13 231.84 237.13 231.84 227.58",
    style: {
      opacity: 0.30000000000000004,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 280.76,
    cy: 206.49,
    r: 3.96,
    style: {
      fill: "#fff",
      opacity: 0.5,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225.88,
    y: 247.73,
    width: 161.29,
    height: 51.5,
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.4,257.28H303.5a2.19,2.19,0,0,1-2.19-2.19h0a2.19,2.19,0,0,1,2.19-2.19h29.9a2.2,2.2,0,0,1,2.2,2.19h0A2.2,2.2,0,0,1,333.4,257.28Z",
    style: {
      fill: "#fff",
      opacity: 0.5,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.4,266.28H303.5a2.19,2.19,0,0,1-2.19-2.19h0a2.19,2.19,0,0,1,2.19-2.19h57.9a2.2,2.2,0,0,1,2.2,2.19h0A2.2,2.2,0,0,1,361.4,266.28Z",
    style: {
      fill: "#fff",
      opacity: 0.5,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 231.84,
    y: 252.9,
    width: 59.51,
    height: 40.73,
    style: {
      opacity: 0.30000000000000004,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "231.84 284.08 245.95 270.74 257.93 282.42 268.34 272.32 291.35 293.63 231.84 293.63 231.84 284.08",
    style: {
      opacity: 0.30000000000000004,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 280.76,
    cy: 262.99,
    r: 3.96,
    style: {
      fill: "#fff",
      opacity: 0.5,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225.88,
    y: 304.23,
    width: 161.29,
    height: 51.5,
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.4,313.78H303.5a2.19,2.19,0,0,1-2.19-2.19h0a2.19,2.19,0,0,1,2.19-2.19h29.9a2.2,2.2,0,0,1,2.2,2.19h0A2.2,2.2,0,0,1,333.4,313.78Z",
    style: {
      fill: "#fff",
      opacity: 0.5,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.4,322.78H303.5a2.19,2.19,0,0,1-2.19-2.19h0a2.19,2.19,0,0,1,2.19-2.19h57.9a2.2,2.2,0,0,1,2.2,2.19h0A2.2,2.2,0,0,1,361.4,322.78Z",
    style: {
      fill: "#fff",
      opacity: 0.5,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 231.84,
    y: 309.4,
    width: 59.51,
    height: 40.73,
    style: {
      opacity: 0.30000000000000004,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "231.84 340.58 245.95 327.24 257.93 338.92 268.34 328.82 291.35 350.13 231.84 350.13 231.84 340.58",
    style: {
      opacity: 0.30000000000000004,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 280.76,
    cy: 319.49,
    r: 3.96,
    style: {
      fill: "#fff",
      opacity: 0.5,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.75,
    y: 104.39,
    width: 176,
    height: 23.14,
    style: {
      opacity: 0.30000000000000004,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "235.06 107.68 227.85 111.73 235.06 115.79 242.27 111.73 235.06 107.68",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "235.06 117.42 230 114.58 227.85 115.79 235.06 119.85 242.27 115.79 240.12 114.58 235.06 117.42",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "235.06 121.48 230 118.64 227.85 119.85 235.06 123.9 242.27 119.85 240.12 118.64 235.06 121.48",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324.29,
    y: 110.75,
    width: 28.09,
    height: 10.08,
    rx: 2.36,
    style: {
      fill: "#38BDF8"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 358.29,
    y: 110.75,
    width: 28.09,
    height: 10.08,
    rx: 2.36,
    style: {
      fill: "#38BDF8"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324.29,
    y: 110.75,
    width: 28.09,
    height: 10.08,
    rx: 2.36,
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 358.29,
    y: 110.75,
    width: 28.09,
    height: 10.08,
    rx: 2.36,
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-284"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--group--inject-284"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M205.9,203.64c-5.14,2.07-9.49-3.08-9.69-9.21,0,0-4.69-3-10-6.26a139.24,139.24,0,0,0-12.35-6.92,4.6,4.6,0,0,1-1.75-1.43h0c-4.1-5.32-2.21-20.65-2.21-20.65,9.5,1.06,28.48,18.27,36.79,26.57S211,201.56,205.9,203.64Z",
    style: {
      fill: "#38BDF8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.21,188.17a139.24,139.24,0,0,0-12.35-6.92,4.6,4.6,0,0,1-1.75-1.43h0l6.64-5.91S184.68,181.62,186.21,188.17Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "174.62 409.55 182.73 410.41 184.25 392.91 176.14 392.05 174.62 409.55",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "134.14 408.96 142 408.96 142.65 390.75 134.78 390.75 134.14 408.96",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.09,408.05h-9.55a.69.69,0,0,0-.67.54l-1.55,7a1.16,1.16,0,0,0,.9,1.37,1,1,0,0,0,.25,0c3.09-.05,5.34-.24,9.22-.24,2.39,0,9.6.25,12.9.25s3.73-3.26,2.38-3.56c-6.06-1.32-10.62-3.15-12.56-4.89A1.89,1.89,0,0,0,143.09,408.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.63,409.14a.19.19,0,0,1-.14-.16.17.17,0,0,1,.09-.18c.28-.18,2.82-1.74,3.69-1.29a.55.55,0,0,1,.32.52,1.09,1.09,0,0,1-.39,1,2.38,2.38,0,0,1-1.51.4A9.47,9.47,0,0,1,143.63,409.14Zm.54-.26a3.82,3.82,0,0,0,2.8-.14.77.77,0,0,0,.25-.67c0-.15-.07-.22-.12-.22a.4.4,0,0,0-.24-.05A7.5,7.5,0,0,0,144.17,408.88Z",
    style: {
      fill: "#38BDF8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.58,409.18a.2.2,0,0,1-.09-.17c0-.11.2-2.37,1.11-3.11a1,1,0,0,1,.79-.24.61.61,0,0,1,.6.49c.16.83-1.41,2.56-2.22,3h-.09A.17.17,0,0,1,143.58,409.18Zm1.26-3.06a4.41,4.41,0,0,0-.93,2.46c.81-.61,1.81-1.92,1.71-2.43,0,0,0-.19-.27-.19h-.09A.67.67,0,0,0,144.84,406.12Z",
    style: {
      fill: "#38BDF8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.59,407.8H174a.69.69,0,0,0-.67.54l-1.55,7a1.16,1.16,0,0,0,.9,1.37,1,1,0,0,0,.25,0c3.09-.05,5.34-.24,9.22-.24,2.39,0,9.6.25,12.9.25s3.73-3.26,2.38-3.56c-6.06-1.32-10.62-3.15-12.56-4.89A1.89,1.89,0,0,0,183.59,407.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.13,408.89a.19.19,0,0,1-.14-.16.17.17,0,0,1,.09-.18c.28-.18,2.82-1.74,3.69-1.29a.55.55,0,0,1,.32.52,1.09,1.09,0,0,1-.39,1,2.38,2.38,0,0,1-1.51.4A9.47,9.47,0,0,1,184.13,408.89Zm.54-.26a3.82,3.82,0,0,0,2.8-.14.77.77,0,0,0,.25-.67c0-.15-.07-.22-.12-.22a.4.4,0,0,0-.24-.05A7.5,7.5,0,0,0,184.67,408.63Z",
    style: {
      fill: "#38BDF8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.08,408.93a.2.2,0,0,1-.09-.17c0-.11.2-2.37,1.11-3.11a1,1,0,0,1,.79-.24.61.61,0,0,1,.6.49c.16.83-1.41,2.56-2.22,3h-.09A.17.17,0,0,1,184.08,408.93Zm1.26-3.06a4.41,4.41,0,0,0-.93,2.46c.81-.61,1.81-1.92,1.71-2.43,0,0,0-.19-.27-.19h-.09A.67.67,0,0,0,185.34,405.87Z",
    style: {
      fill: "#38BDF8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "176.14 392.05 184.25 392.91 183.46 401.94 175.35 401.08 176.14 392.05",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "134.78 390.76 142.65 390.76 142.31 400.15 134.44 400.15 134.78 390.76",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138,231h41.72c4,21.67,16.38,98.33,7.48,166.63L173.1,395.9s1.31-90.68-11.16-124.2c-1.44,17.94-3.14,37-4.62,47.19-3.63,25-11.4,79.63-11.4,79.63H131.54s2.94-52.29,4.3-76.86C137.33,295,138,236.5,138,231Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.54,398.52h14.38s7.77-54.64,11.4-79.64c1.48-10.15,3.18-29.24,4.62-47.18a111.8,111.8,0,0,1,4.66,18.05c7.45,40.21,6.5,106.15,6.5,106.15l14.12,2c8.91-68.31-3.5-145.38-7.47-166.38H138c-.06,5-.7,63.71-2.19,90.38C134.48,346.47,131.54,398.52,131.54,398.52Z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "188.84 400.94 171.36 398.34 171.89 393.5 190.08 395.89 188.84 400.94",
    style: {
      fill: "#38BDF8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "147.65 398.64 130.69 398.64 130.69 393.57 148.29 393.24 147.65 398.64",
    style: {
      fill: "#38BDF8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.94,271.7a111.8,111.8,0,0,1,4.66,18.05c1.17-16-3.5-32.89-3.5-32.89Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.33,211.58s19.45,18.06,21.29,19.94,1.72,15.33,0,15.93-7.27,1.58-7.47,0,.4-10.29.4-10.29l1.25-1.78L109.37,220Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.8,162.53C117.09,165,97.38,190.44,100,207.19c1.71,11.18,13,17.31,13,17.31l9.12-9.52s-5.77-5.08-6.92-8.3c-3.43-9.59,9.09-24.31,19.37-27.34l2.12-8.57Z",
    style: {
      fill: "#38BDF8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.8,162.53a176.11,176.11,0,0,1,5,25.87c.33,2.68.6,5.31.82,7.86.29,3.24.49,6.36.65,9.32.2,3.75.26,8.18.25,12.54,0,10-.42,19.65-.42,19.65,8,2,31.12.67,43.75-.25A201,201,0,0,0,182,201.11a208,208,0,0,0-2.65-23.93,102.87,102.87,0,0,0-2.82-12.52,8,8,0,0,0-6.64-5.51c-1.53-.19-3.3-.38-5.16-.49-.72,0-1.44-.07-2.17-.08a154.22,154.22,0,0,0-17.84,1.24c-1.12.13-2.26.3-3.36.48A102.46,102.46,0,0,0,130.8,162.53Z",
    style: {
      fill: "#38BDF8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.85,237.53c-12.63.92-35.75,2.25-43.75.25,0,0,.4-9.63.42-19.65,0-4.36-.05-8.79-.25-12.54-.16-3-.36-6.08-.65-9.32-.22-2.55-.49-5.18-.82-7.86-.08-.72-.17-1.45-.27-2.17-.29-2.31-.64-4.61-1-6.9l0-.06,3.89-5.6,7.73-11.14s12.86,5.2,18.2-2.22a86.41,86.41,0,0,1,14.39,13.58c.21,1,.41,2.14.61,3.29A208,208,0,0,1,182,201.12,201,201,0,0,1,180.85,237.53Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.1,124.94s1.33,8.92-4.42,13.08-5.75-16-5.75-16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.72,159.77c3.83,3.48,13.21,2.2,13.21,2.2s5.86-1.61,4.63-3.44c-3.45-.57-5.12-2.18-5.81-4.24a10,10,0,0,1-.35-3.94,20.71,20.71,0,0,1,.29-2.2l-11.6-8.59C146.61,145.23,148.47,155.66,144.72,159.77Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.77,145c.46,7,6.18,8.88,9,9.27a10,10,0,0,1-.35-3.94Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147,146.63a9.83,9.83,0,0,0,11.29,3.81,11,11,0,0,0,6.25-5.09,11.2,11.2,0,0,0,.52-1c2.83-6.62,3.73-18.2-3.27-22.54a10.66,10.66,0,0,0-16.28,8C144.64,137.54,143.77,142.05,147,146.63Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.78,133.94c-.15.61.14,1.18.55,1.25s.83-.38.94-1-.15-1.19-.55-1.26S156.9,133.31,156.78,133.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.85,135.14c-.15.62.14,1.19.55,1.26s.82-.39.93-1-.14-1.18-.55-1.25S164,134.55,163.85,135.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.55,135.07a23,23,0,0,0,2.07,5.86,3.65,3.65,0,0,1-3.1,0Z",
    style: {
      fill: "#de5753"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155,131.28a.38.38,0,0,0,.38-.09,3,3,0,0,1,2.56-.82.38.38,0,0,0,.45-.27.37.37,0,0,0-.27-.45h0a3.69,3.69,0,0,0-3.24,1,.36.36,0,0,0,0,.52h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159,144h0a5.72,5.72,0,0,1-4.63-2.52.19.19,0,0,1,.07-.27.19.19,0,0,1,.26.05v0a5.46,5.46,0,0,0,4.31,2.32.19.19,0,0,1,.19.19v0a.2.2,0,0,1-.19.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.3,133.23a.38.38,0,0,0,.21.05.37.37,0,0,0,.26-.46h0a3.71,3.71,0,0,0-2.29-2.52.37.37,0,0,0-.46.25h0a.37.37,0,0,0,.25.46h0a3,3,0,0,1,1.78,2A.39.39,0,0,0,167.3,133.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157,117.37c-.93-.13-1.85-.24-2.78-.28a13.78,13.78,0,0,0-7.75,1.55c-5.35,3.17-4.43,11.29-3.74,16.55.92,7,3.67,10.17,3.67,10.17-1.67-3.34-1.17-9.84-.08-10s1,1.08,1,1.08c2.41-1.5,4.58-5.75,3.83-8.75-.57-2.3,2-4,4.17-2.92l.65.32c.32.16.67.32,1,.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.07,135.52a7.42,7.42,0,0,0,3.56,4.41c2.29,1.23,4-.68,3.84-3.14-.16-2.18-1.51-5.52-4.05-5.71S140.42,133.21,141.07,135.52Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160,124c-.5.89.76,3.76-2.11,3.06s-3.07.54-5.11,2.51-6.16-1-6.16-1l-4.51.59s-3.29-3-1.23-4.55,2.51-3.86,3.78-6.53,6.86-6.13,12.82-2.07c0,0,3.16-1.09,4.55-.3a8.39,8.39,0,0,1,2.51,2.87,2.13,2.13,0,0,1,3.21-.1c1.62,1.68.33,7.71,1.72,9.2s-1.72,3.38-1.72,3.38-2.43-.58-2.43-2.36c0-3.17-.47-4.3-2-4.88a1.45,1.45,0,0,0-1.61.49S160.85,122.61,160,124Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.53,186.24c-.29-2.31-.64-4.61-1-6.9l0-.06c.34-.57,3.13-5.24,3.41-8.58a20.2,20.2,0,0,1,.48,3C138.72,176.87,138.58,182.05,135.53,186.24Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.83,178.93l1,8a2.19,2.19,0,0,0,2.26,1.93l16.76-.64a2.19,2.19,0,0,0,2.1-2.37l-.66-8.13a2.2,2.2,0,0,0-2.28-2l-17.07.73A2.2,2.2,0,0,0,149.83,178.93Z",
    style: {
      fill: "#38BDF8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "157.93 179.48 165 181.79 158.29 185.15 160.11 182.32 157.93 179.48",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.21,174.62l4.51-18a1.57,1.57,0,0,1,1.52-1.19h9.46a.91.91,0,0,1,.88,1.13l-4.41,17.95a1.56,1.56,0,0,1-1.52,1.19h-9.56A.91.91,0,0,1,172.21,174.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.32,162.53a2.49,2.49,0,0,0-2.08,2c-.28,1.1.21,2,1.1,2a2.51,2.51,0,0,0,2.09-2C182.7,163.42,182.21,162.53,181.32,162.53Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.39,192.42S195.14,174.05,192,171.24s-15-4.87-15.39-5-2.9,10.44-1.78,11.35,11.54,1.93,12.22,1.65,1.84-.73,1.84-.73L199,198.37S204.8,198,206.39,192.42Z",
    style: {
      fill: "#e4897b"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllCaughtUp);
export default __webpack_public_path__ + "static/media/all-caught-up.5457c25f06ea6b96e63c0fc7b86e9392.svg";
export { ForwardRef as ReactComponent };